// extracted by mini-css-extract-plugin
export var elevation1Dp = "elevation1Dp___psfsV";
export var elevation2Dp = "elevation2Dp___Djw2B";
export var elevation3Dp = "elevation3Dp___wQSEW";
export var elevation4Dp = "elevation4Dp___ajFSG";
export var elevation5Dp = "elevation5Dp____ndiA";